<template>
  <div class="container">
    <div class="flex header">
      <img class="logo" alt="logo" src="../assets/LOGO.jpeg">
      <h2 class="title">정겨운 남성역 골목시장</h2>
    </div>
    <div class="flex flex-col">
      <div v-for="item in infos" :key="item.name" class="flex block_container">
        <BlockItem :name="item.name" :type="item.type" :location="item.location" :number="item.number" :mapLink="item.mapLink"/>
      </div>

    </div>
  </div>
</template>

<script>
import BlockItem from '../components/BlockItem.vue'
import info from '../data/data.json'

export default {
  name: 'MainPage',
  props: {
    msg: String
  },
  components: {
    BlockItem
  },
  data() {
    return {
      infos: info
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&family=Noto+Sans:ital,wght@0,100;0,400;0,500;0,600;0,700;1,500;1,600&family=Roboto:ital,wght@0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');
.flex {display: flex;}
.flex-col {flex-direction: column}

.container {
  width: 100vw;
  height: auto;
  background-color: #FBF4EF;
}
.header {
  margin-bottom: 15px;
}

.logo {
  width: 80px;
  border-radius: 0 0 20px 0;
  //filter: drop-shadow(3px 7px 9px #dedede);
}

.block_container {
  justify-content: center;
  padding-top: 20px;
}

.title {
  margin-left: 35px;
  margin-top: 20px;
  color: #076ba7;

  font-size: 35px;
  font-family: 'Nanum Brush Script', cursive;
}
</style>
